module.exports = __webpack_public_path__ + "img/u-newemail.5ce607c4.jpg";